import { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Paper,
  Select,
  MenuItem,
  Typography,
  Grid,
  Stack,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Card,
  CardContent,
  Menu,
  IconButton,
  Tooltip,
  Container,
  CircularProgress,
  Switch,
} from "@mui/material";
import SiteWrapper from "../SiteWrapper.react";
import { useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
//import ProjectTypeService from '../services/projectType.service';
//import ElementTypeService from '../services/elementType.service';
import useMediaQuery from "@mui/material/useMediaQuery";
import infoJiraProjectsService from "../services/infoJiraProjects.service";
import ProjectService from "../services/project.service";
import { toast } from "react-toastify";
import {
  HelperDialog,
  TrueffortButton,
  TrueffortChip,
  TrueffortConfirmAlert,
  TrueffortNavButton,
} from "../MUIstyle/MUICustom";
import {
  Dashboard as DashboardIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  CheckCircle as CheckCircleIcon,
  Settings as SettingsIcon,
  Info as InfoIcon,
  Cached as CachedIcon,
  AppRegistration as AppRegistrationIcon,
  Help as HelpIcon,
} from "@mui/icons-material";
import CustomIconTrueffortScreen from "../components/custom/CustomIconTrueffortScreen";
import ProjectElementService from "../services/projectElement.service";
import infoAzureProjectsService from "../services/InfoAzureProject.service";
import EstimationsService from "../services/estimations.service";
import TaskStateService from "../services/taskState.service";
import { useAuthContext } from "../contexts/AuthenticationContext";
import InteroperabilityService from "../services/interoperabilty.service";
import Limit from "../components/estimation/Limit";
import TableElementsInteroperability from "../components/estimation/TableElementsInteroperability";
import RelatedUsers from "../components/estimation/RelatedUsers";
import { confirmAlert } from "react-confirm-alert";
import RelatedStatus from "../components/estimation/RelatedStatus";
import { helperDialogs } from "../util/HelperDialogs";
import { TOOLS_EXTERNAL_NAME } from "../util/Constants";
import { formatSeconds } from "../util/GlobalFunctions";

const APIProjectsInfo = () => {
  const location = useLocation();
  const {
    selectedAPI,
    projectId,
    projectName,
    organizationDomain,
    email,
    token,
    trueffortId,
  } = location.state || {};
  const { user } = useAuthContext();
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  const [idSelectedEstimationType, setIdSelectedEstimationType] = useState(
    () => {
      switch (selectedAPI) {
        case TOOLS_EXTERNAL_NAME.jira:
          return "1";
        case TOOLS_EXTERNAL_NAME.azure:
          return "4";
        default:
          return "2";
      }
    },
  );
  const [projectTypes, setProjectTypes] = useState([]);
  const [idSelectedProjectType, setIdSelectedProjectType] = useState("");
  const [selectedProjectType, setSelectedProjectType] = useState({});
  const [elementTypes, setElementTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  //const [estimationUpdateNeeded, setEstimationUpdateNeeded] = useState(true);
  const [projectElements, setProjectElements] = useState([]);
  const [syncedElements, setSyncedElements] = useState([]);
  const [estimation, setEstimation] = useState({});
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [selectedSprints, setSelectedSprints] = useState([]);
  const [sprints, setSprints] = useState([]);
  const [sprintsFromTasks, setSprintsFromTasks] = useState([]);
  const [durationInputErrorMessage, setDurationInputErrorMessage] =
    useState("");
  const [totalDuration, setTotalDuration] = useState(0);
  const [statusesProject, setStatusesProject] = useState([]);
  const [rankedUsers, setRankedUsers] = useState([]);
  const [notrankedUsers, setNotRankedUsers] = useState([]);
  const [users, setUsers] = useState([]);
  const [internallyRelatedUsers, setInternallyRelatedUsers]: any = useState();
  const [menuNumber, setMenuNumber] = useState(0);
  const [anchorElemFilter, setAnchorElemFilter] = useState(null);
  const openOptions = Boolean(anchorElemFilter);
  const [selectedElementIdsToDelete, setSelectedElementIdsToDelete] = useState(
    [],
  );

  const projectElementService = useMemo(() => new ProjectElementService(), []);
  const estimationsService = useMemo(() => new EstimationsService(), []);
  const taskStateService = useMemo(() => new TaskStateService(), []);
  const interoperabilityService = useMemo(
    () => new InteroperabilityService(),
    [],
  );
  const [relationshipUserTool, setRelationshipUserTool]: any = useState([]);
  const [issues, setIssues]: any = useState([]);

  const MAP_INTER_STATUS = {
    jira: [
      { id: 1, name: "Creada", keyRelation: "new", relation: "To Do" },
      {
        id: 2,
        name: "En proceso",
        keyRelation: "indeterminate",
        relation: "In Progress",
      },
      { id: 3, name: "Cancelada", keyRelation: "", relation: "" },
      { id: 4, name: "Terminada", keyRelation: "done", relation: "Done" },
    ],
    azure: [
      {
        id: 1,
        name: "Creada",
        relations: [
          { keyRelation: "To Do", relation: "To Do" },
          { keyRelation: "New", relation: "Proposed" },
        ],
      },
      {
        id: 2,
        name: "En proceso",
        relations: [
          { keyRelation: "Doing", relation: "In Progress" },
          { keyRelation: "Active", relation: "In Progress" },
        ],
      },
      { id: 3, name: "Cancelada", relations: [] },
      {
        id: 4,
        name: "Terminada",
        relations: [
          { keyRelation: "Done", relation: "Complete" },
          { keyRelation: "Resolved", relation: "Resolved" },
          { keyRelation: "Closed", relation: "Completed" },
        ],
      },
    ],
  };
  const [relationsStatuses, setRelationsStatuses]: any = useState([]);

  const isElementMappedToTerminada = (elem: any) => {
    const terminadaRelation = relationsStatuses.find(
      (status: any) => status.name === "Terminada" || status.id === 4,
    );

    if (!terminadaRelation?.statusTool?.length) {
      return false;
    }

    return terminadaRelation.statusTool.some((statusTool: any) => {
      return (
        String(statusTool.id) === String(elem.idStatus) ||
        String(statusTool.name) === String(elem.status)
      );
    });
  };

  const saveableProjectElements = useMemo(() => {
    return projectElements.filter(
      (elem: any) => !isElementMappedToTerminada(elem),
    );
  }, [projectElements, relationsStatuses]);

  const minEstimatedDays =
    saveableProjectElements.length === 0
      ? 1
      : saveableProjectElements.reduce(
          (acc: number, element: any): boolean =>
            acc < element.estimatedDays ? element.estimatedDays : acc,
          0,
        );
  let maxEstimatedDays =
    saveableProjectElements.length === 0
      ? 1
      : saveableProjectElements.reduce(
          (acc: number, element: any): number => acc + element.estimatedDays,
          0,
        );
  const totalHours = saveableProjectElements.reduce(
    (acc: number, element: any): number => acc + element.estimatedTime,
    0,
  );

  useEffect(() => {
    initScreen();
  }, []);

  const initScreen = () => {
    interoperabilityService
      .getConfigScreenEstimation(selectedAPI)
      .then(({ data: response }: any) => {
        if (response.success) {
          const { users, templates, knowUsers } = response.data;
          //console.log(users);
          //console.log(knowUsers);
          setInternallyRelatedUsers(knowUsers);
          setUsers(users);
          setProjectTypes(templates);
          let projectType = templates.find(
            (p: any) => p.name == user.baseTemplateName,
          );
          let id = "";
          if (projectType) {
            setIdSelectedProjectType(projectType.idProjectType);
            setSelectedProjectType(projectType);
            id = projectType?.elementTypeList[0].idElementType;
          } else {
            setIdSelectedProjectType(templates[0].idProjectType);
            setSelectedProjectType(templates[0]);
            id =
              templates[0].elementTypeList.length == 1
                ? templates[0].elementTypeList[0].idElementType
                : "";
          }
          fetchProjectTasks(
            organizationDomain,
            email,
            token,
            projectId,
            id,
            knowUsers,
            projectType.idProjectType,
          );
        }
      })
      .catch((ex: any) => console.log(ex));
  };

  useEffect(() => {
    getProjectSprints();
    updateUserLists();
  }, [projectTypes]);

  const updateUserLists = () => {
    const assignedUserIds = projectElements.map(
      (elem: any) => elem.assignedUser,
    );
    setRankedUsers(
      users.filter((elem: any) => assignedUserIds.includes(users.idUser)),
    );
    setNotRankedUsers(
      users.filter((elem: any) => !assignedUserIds.includes(users.idUser)),
    );
  };

  const deleteUser = (usr: any, elemId: any) => {
    const updatedProjectElements = projectElements.map((elem: any) => {
      if (elem.apiID === elemId && elem.assignedUser === usr.idUser) {
        return { ...elem, assignedUser: "" };
      }
      return elem;
    });
    setProjectElements(updatedProjectElements);
    updateUserLists();
  };

  const filteredElements = useMemo(() => {
    return projectElements.filter((elem: any) => {
      const statusMatch =
        selectedStatuses.length == 0 ||
        selectedStatuses.map((st: any) => st.id).includes(elem.idStatus);

      const sprintMatch =
        selectedSprints.length === 0 ||
        selectedSprints.includes(
          typeof elem.sprints === "string" ? elem.sprints : elem.sprints[0],
        );

      return statusMatch && sprintMatch;
    });
  }, [projectElements, selectedStatuses, selectedSprints]);

  const createRelationsStatus = (issues_: any) => {
    //console.log(issues_);
    let results: any = [];
    switch (selectedAPI) {
      case TOOLS_EXTERNAL_NAME.jira:
        MAP_INTER_STATUS.jira.forEach((stTrue: any) => {
          let obj = { ...stTrue };
          let statusChild: any = [];
          let stAdd: any = {};
          issues_.forEach((is: any) => {
            //console.log(is);
            if (
              !stAdd[is.fields.status.id] &&
              (is.fields.status.statusCategory.key == stTrue.keyRelation ||
                is.fields.status.statusCategory.name == stTrue.relation)
            ) {
              stAdd[is.fields.status.id] = is.fields.status;
              statusChild.push({
                id: is.fields.status.id,
                name: is.fields.status.name,
                value: is.fields.status.id,
                label: is.fields.status.name,
              });
            }
          });
          obj["statusTool"] = statusChild;
          results.push(obj);
        });

        return results;
      case TOOLS_EXTERNAL_NAME.azure:
        MAP_INTER_STATUS.azure.forEach((stTrue: any) => {
          let obj = { ...stTrue };
          let statusChild: any = [];
          let stAdd: any = {};
          let rels = stTrue.relations.map((rel: any) => rel.keyRelation);
          issues_.forEach((is: any) => {
            if (
              !stAdd[is.fields["System.State"]] &&
              rels.includes(is.fields["System.State"])
            ) {
              stAdd[is.fields["System.State"]] = is.fields["System.State"];
              statusChild.push({
                id: is.fields["System.State"],
                name: is.fields["System.State"],
                value: is.fields["System.State"],
                label: is.fields["System.State"],
              });
            }
          });
          obj["statusTool"] = statusChild;
          results.push(obj);
        });
        return results;
    }
  };

  useEffect(() => {
    //console.log(createRelationsStatus(issues));
    setRelationsStatuses(createRelationsStatus(issues));
  }, [issues]);

  // Utiliza el hook useEffect para llamar a la función fillElementTypes cada vez que cambia el estado idSelectedProjectType
  useEffect(() => {
    //fillElementTypes();
    setElementTypes(selectedProjectType.elementTypeList);
    let id =
      selectedProjectType?.elementTypeList?.length == 1
        ? selectedProjectType?.elementTypeList[0]?.idElementType
        : "";
    let pes = projectElements.map((pe: any) => {
      return { ...pe, idElementType: id };
    });
    if (id != "" && ["2", "3"].includes(idSelectedEstimationType)) {
      getEstimate(
        id,
        pes.map((elem: any) => ({
          id: elem.idElementType,
          id_size: elem.idSize,
          id_complexity: elem.idComplexity,
        })),
        pes,
        true,
      );
    }
    setProjectElements(pes);
  }, [selectedProjectType]);

  /*useEffect(() => {
    setProjectElements(projectElements.map((pe: any) => { return { ...pe, idElementType: elementTypes.length == 1 ? elementTypes[0].idElementType : '' } }));
  }, [elementTypes]);*/

  const fetchProjectTasks = async (
    organizationDomain: any,
    email: any,
    token: any,
    projectId: any,
    idElementType: any,
    intRelatedUsers: any,
    idProjectType: any,
  ) => {
    try {
      setIsLoading(true); // Indicar que se están cargando los datos

      let response;
      if (selectedAPI === TOOLS_EXTERNAL_NAME.jira) {
        response = await infoJiraProjectsService.getProjectDetails(
          organizationDomain,
          email,
          token,
          projectId,
        );
        //console.log("JIRA T", JSON.stringify(response.data));
        let usuariosAsignados = response.data?.data.filter(
          (is: any) => is.fields.assignee != null,
        );
        //console.log(usuariosAsignados);
        let usersClean: any = [];
        usuariosAsignados.forEach((ua: any) => {
          let obj = usersClean.find(
            (uc: any) => uc?.accountId == ua.fields.assignee.accountId,
          );
          if (obj == null) {
            usersClean.push(ua.fields.assignee);
          }
        });
        //console.log(intRelatedUsers);
        let relations = usersClean.map((uc: any) => {
          let obj_ = intRelatedUsers.find(
            (int: any) => int.idToolUser == uc.accountId,
          );
          return {
            name: uc.displayName,
            email: uc.emailAddress,
            id: uc.accountId,
            idUser: obj_?.idUser,
            error: "",
          };
        });
        setRelationshipUserTool(relations);
        //console.log(usuariosAsignados)
        //console.log(relations, idElementType, idProjectType);
        manageJiraIssues(
          response.data?.data,
          relations,
          idElementType,
          idProjectType,
        );
        setStatusesProject(response.data?.statuses);
        setIssues(response.data?.data);
        //console.log(JSON.stringify(response.data?.data));
        //setIsLoading(false);
      } else if (selectedAPI === TOOLS_EXTERNAL_NAME.azure) {
        response = await infoAzureProjectsService.getWorkItemDetails(
          organizationDomain,
          token,
          projectId,
        );
        //console.log("AZURE T", response.details);

        let usuariosAsignados = response.details.data.filter(
          (is: any) => is.fields["System.AssignedTo"],
        );
        //console.log(usuariosAsignados);
        let usersClean: any = [];
        usuariosAsignados.forEach((ua: any) => {
          //console.log(usersClean);
          let obj = usersClean.find(
            (uc: any) => uc?.id == ua.fields["System.AssignedTo"].id,
          );
          if (obj == null) {
            usersClean.push(ua.fields["System.AssignedTo"]);
          }
        });
        //console.log(usersClean);
        let relations = usersClean.map((uc: any) => {
          let obj_ = intRelatedUsers.find(
            (int: any) => int.idToolUser == uc.id,
          );
          return {
            name: uc.displayName,
            email: uc.uniqueName,
            id: uc.id,
            idUser: obj_?.idUser,
            error: "",
          };
        });
        //console.log(relations);
        setRelationshipUserTool(relations);
        manajeAzureWorkItems(
          response.details.data,
          relations,
          idElementType,
          idProjectType,
        );
        setIssues(response.details.data);
        setStatusesProject(response.details?.statuses);
      }
    } catch (error) {
      // Manejar el error aquí
      console.error("Error fetching project tasks", error);
      setIsLoading(false); // Finalizar la carga, independientemente del resultado
    }
  };

  /**
   *
   * Funciones comunes
   *
   */

  const getRelationsAsObject = (rel: any) => {
    let relDes: any = {};
    rel.forEach((element: any) => {
      relDes[element.id] = element;
    });
    //console.log(relDes);
    return relDes;
  };

  const getProjectSprints = () => {
    switch (selectedAPI) {
      case TOOLS_EXTERNAL_NAME.jira:
        getJiraProjectSprints();
        break;

      case TOOLS_EXTERNAL_NAME.azure:
        getAzureProjectSprints();
        break;
    }
  };

  const isElmentInTrueffort = (keyTaskJira: string, trueffortElems: any) => {
    if (trueffortElems.length > 0 && typeof keyTaskJira != "undefined") {
      let exists = trueffortElems.find(
        (e: any) => e.idToolTask === keyTaskJira,
      );
      return typeof exists != "undefined";
    } else {
      return false;
    }
  };

  const handleChangeProjectTypeSelect = (id: any) => {
    // Establece el tipo de proyecto seleccionado
    setIdSelectedProjectType(id);
    // Busca el tipo de proyecto seleccionado en la lista de tipos de proyecto y lo establece como seleccionado
    let pt = projectTypes.find((pt: any) => pt.idProjectType == id);
    setSelectedProjectType(pt);
    //console.log(pt);
    //projectTypes.forEach((p: any) => {
    //if (p.idProjectType == id) {
    //setSelectedProjectType(p);
    /*getEstimate(projectElements.map((elem: any) => (
          {
            id: elem.idElementType,
            id_size: elem.idSize,
            id_complexity: elem.idComplexity
          }
        )),projectElements)*/
    //setEstimationUpdateNeeded(true);
    //  }
    //});

    /*for (let i: number = 0; i < projectElements.length; i++) {
      projectElements[i].idElementType = "";
    }*/
  };

  const handleChangeEstimationType = (id: any) => {
    //console.log(id);
    setIdSelectedEstimationType(id);
    let idElemT =
      selectedProjectType?.elementTypeList.length == 1
        ? selectedProjectType?.elementTypeList[0].idElementType
        : "";
    switch (id) {
      case "1":
        //setEstimationUpdateNeeded(false);
        manageJiraIssues(
          issues,
          relationshipUserTool,
          idElemT,
          idSelectedProjectType,
        );
        break;
      case "4":
        //setEstimationUpdateNeeded(false);
        manajeAzureWorkItems(
          issues,
          relationshipUserTool,
          idElemT,
          idSelectedProjectType,
        );
        break;
      case "2":
      case "3":
        getEstimate(
          idSelectedProjectType,
          projectElements.map((elem: any) => ({
            id: elem.idElementType,
            id_size: elem.idSize,
            id_complexity: elem.idComplexity,
          })),
          projectElements,
          true,
        );
        //setEstimationUpdateNeeded(true);
        break;
    }
  };

  const handleStateUpdate = (
    id: number,
    type: string,
    trueffortStatus: any,
    state: string,
  ) => {
    setIsSaving(true);
    if (selectedAPI === TOOLS_EXTERNAL_NAME.azure) {
      syncAzureState(id, type, trueffortStatus, state);
    } else {
      syncJiraState(id, trueffortStatus, state);
    }
  };

  // Prepara el Filtro por status
  const handleChangeStatus = (status: any) => {
    setAnchorElemFilter(null);
    if (status.name === "all") {
      setSelectedStatuses([]);
      //setProjectTasksFiltered(projectTasks);
      return;
    }
    //let selectedStatusesCopy = [...selectedStatuses];
    let selectedStatusesCopy = selectedStatuses.flat();
    let alreadySelected = selectedStatuses.find((s: any) => s.id === status.id);

    if (!alreadySelected) {
      selectedStatusesCopy.push(statusesProject.find((s: any) => s === status));
    } else {
      // Si ya estaba seleccionarlo, deseleccionarlo
      selectedStatusesCopy = selectedStatusesCopy.filter(
        (item: any) => item.id !== status.id,
      );
    }
    console.log("Status Filter Applied:", selectedStatusesCopy);
    setSelectedStatuses(selectedStatusesCopy);
  };

  const handleChangeSprint = (sprint: string) => {
    setAnchorElemFilter(null);
    if (sprint === "all") {
      setSelectedSprints([]);
      return;
    }
    let selectedSprintsCopy = [...selectedSprints];
    let alreadySelected = selectedSprints.find((s: any) => s === sprint);

    if (typeof alreadySelected === "undefined") {
      selectedSprintsCopy.push(sprintsFromTasks.find((s: any) => s === sprint));
    } else {
      selectedSprintsCopy = selectedSprintsCopy.filter(
        (item: any) => item !== sprint,
      );
    }
    setSelectedSprints(selectedSprintsCopy);
    //console.log("Sprint Filter Applied:", selectedSprintsCopy);
  };

  useEffect(() => {
    //console.log(relationshipUserTool);
    //console.log(projectElements);
    let relO = getRelationsAsObject(relationshipUserTool);
    let items = projectElements.map((pe: any) => {
      return {
        ...pe,
        assignedUser:
          pe?.assignedUserToInter != ""
            ? relO[pe?.assignedUserToInter]?.idUser || ""
            : pe?.assignedUserToInter,
      };
    });
    setProjectElements(items);
  }, [relationshipUserTool]);

  /**
   *
   * response Funciones de Jira
   *
   * */

  const manageJiraIssues = async (
    issues_: any,
    relations: any,
    idElementType: any,
    idProjectType: any,
  ) => {
    let filteredIssues = [];
    if (trueffortId !== -1) {
      // Si el proyecto ya está registrado en Trueffort, filtrar los elementos ya guardados
      const trueffortElems = await projectElementService.getByIdJiraProject(
        projectId,
        trueffortId,
      );
      filteredIssues = issues_.filter(
        (issue: any) =>
          !isElmentInTrueffort(issue.id, trueffortElems.data.data),
      );
      setSyncedElements(
        issues_
          .filter((issue: any) =>
            isElmentInTrueffort(issue.id, trueffortElems.data.data),
          )
          .map((issue: any) => ({
            apiID: issue.id,
            name: issue.fullTitle,
            trueffortStatus: trueffortElems.data.data.find(
              (elem: any) => elem.idToolTask === issue.id,
            ).projectElement.status,
            status: issue.fields.status.name,
            sprints: issue.fields.customfield_10020
              ? issue.fields.customfield_10020.map((sprint: any) => sprint.name)
              : [],
          })),
      );
    } else {
      filteredIssues = issues_;
    }
    
    // Obtener los estatus
    // @ts-ignore
    let sprintsFromTasksAux = [];
    /*console.log(idElementType);
    console.log(issues);
    console.log(filteredIssues);*/
    filteredIssues.map((issue: any) => {
      const sprintField = issue.fields.customfield_10020;
      if (sprintField && Array.isArray(sprintField)) {
        sprintField.forEach((sprint: any) => {
          // @ts-ignore
          if (!sprintsFromTasksAux.includes(sprint.name)) {
            sprintsFromTasksAux.push(sprint.name);
          }
        });
      }
    });
    // @ts-ignore
    setSprintsFromTasks(sprintsFromTasksAux);
    //console.log(elementTypes);
    //console.log(relations);
    let relDes: any = getRelationsAsObject(relations);
    //console.log(filteredIssues);
    //setProjectElementsInter(filteredIssues);
    let elements = filteredIssues.map((issue: any) => {
      const original = Number(issue.fields.timeoriginalestimate) || 0;
      const timeSpent = Number(issue.fields.timespent) || 0;
      return {
        apiID: issue.id,
        name: issue.fullTitle,
        idStatus: issue.fields.status.id,
        status: issue.fields.status.name,
        creationDate: issue.fields.created,
        idElementType,
        estimatedDays: Math.ceil(Math.ceil(original / 3600) / 8),
        estimatedTime: parseFloat((original / 3600).toFixed(2)),
        dedicatedTime : timeSpent,
        durationMax: 0,
        durationMin: 0,
        effortMin: 0,
        effortMax: 0,
        idSize: 2,
        idComplexity: 2,
        sprints: issue.fields.customfield_10020
          ? issue.fields.customfield_10020.map((sprint: any) => sprint.name)
          : [],
        assignedUser: relDes[issue?.fields?.assignee?.accountId]?.idUser || "",
        assignedUserToInter: issue?.fields?.assignee?.accountId || "",
        estimatedTimeTool: parseFloat(
          (issue.fields.timeoriginalestimate / 3600).toFixed(2),
        ),
        trEffortSug: 0,
        trEffortMinSug: 0,
        trEffortMaxSug: 0,
        estimatedDaysTool: Math.ceil(
          Math.ceil(issue.fields.timeoriginalestimate / 3600) / 8,
        ),
        trDurationSug: 0,
        trDurationMinSug: 0,
        trDurationMaxSug: 0,
      };
    });

    if (idElementType != "" && idProjectType != "") {
      let esti_ = await getEstimate(
        idProjectType,
        elements.map((elem: any) => ({
          id: elem.idElementType,
          id_size: elem.idSize,
          id_complexity: elem.idComplexity,
        })),
        elements,
        false,
      );
      //console.log(esti_);
      for (let i = 0; i < elements.length; i++) {
        let eleFind = esti_?.projectElements.find(
          (pe: any) => pe.apiID == elements[i].apiID,
        );
        elements[i] = {
          ...elements[i],
          trEffortSug: eleFind?.estimatedTime || 0,
          trEffortMinSug: eleFind?.effortMin || 0,
          trEffortMaxSug: eleFind?.effortMax || 0,
          trDurationSug: eleFind?.estimatedDays || 0,
          trDurationMinSug: eleFind?.durationMin || 0,
          trDurationMaxSug: eleFind?.durationMax || 0,
        };
      }
    }
    //console.log(elements);
    setProjectElements(elements);
    //setTotalHours(elements.reduce((acc: number, elem: any) => acc + elem.estimatedTime, 0));

    let maxDuration = elements.reduce(
      (acc: number, elem: any) => acc + elem.estimatedDays,
      0,
    );
    let minDuration = elements.reduce(
      (acc: number, elem: any) =>
        acc < elem.estimatedDays ? elem.estimatedDays : acc,
      0,
    );
    //maxEstimatedDays = maxDuration;
    //minEstimatedDays = minDuration;
    //console.log(maxDuration);
    //console.log(minDuration);
    setTotalDuration(Math.round((maxDuration + minDuration) / 2));
    console.log("finalizar");
    setIsLoading(false); // Finalizar la carga, independientemente del resultado
    //setEstimationUpdateNeeded(false);
  };

  const getJiraProjectSprints = () => {
    // PARA OBTENER LOS SPRINTS PRIMERO SE TIENEN QUE OBTENER LOS BOARDS
    infoJiraProjectsService
      .getProjectBoards(organizationDomain, email, token, projectId)
      .then(({ data: response }: any) => {
        //console.log("BOARDS", response);
        if (typeof response != "undefined" && Array.isArray(response)) {
          response.map((b: any) => {
            // Consultar sprints del board
            infoJiraProjectsService
              .getBoardSprints(organizationDomain, email, token, b.id)
              .then(({ data: response }: any) => {
                //console.log("SP", response);
                if (Array.isArray(response.values)) {
                  setSprints(response.values);
                }
              })
              .catch((error) => {
                if (error.response.status === 400) {
                  console.log("El tablero no soporta sprints");
                }
              });
          });
        }
      });
  };

  const updateJiraState = (id: number, transition: any) => {
    const datos = {
      issueId: id,
      transition: transition,
    };

    infoJiraProjectsService
      .updateIssueStatus(organizationDomain, email, token, datos)
      .then(({ data: response }) => {
        if (response.success) {
          fetchProjectTasks(
            organizationDomain,
            email,
            token,
            projectId,
            "",
            internallyRelatedUsers,
            idSelectedProjectType,
          );
          getProjectSprints();
          updateUserLists();

          toast.success(t("Herramienta.jira_state_updated"));
        } else {
          toast.error(t("Herramienta.jira_state_update_error"));
        }
      })
      .catch((error: any) => {
        toast.error(t("Herramienta.jira_state_update_error"));
      });
  };

  const syncJiraState = async (
    id: number,
    trueffortStatus: any,
    state: string,
  ) => {
    try {
      console.log(id, trueffortStatus, state);
      const responseJira = await infoJiraProjectsService.getIssueTransitions(
        organizationDomain,
        email,
        token,
        id,
      );
      const responseStatusInt =
        await taskStateService.getStatusInteroperability(
          1,
          trueffortStatus.idStatus,
        );
      console.log(responseJira.data);
      console.log(responseStatusInt.data);
      if (responseJira.data.success && responseStatusInt.data.success) {
        console.log("dentro");
        if (responseStatusInt.data.data === null) {
          toast.error(t("Herramienta.no_compatible_jira_state"));
          setIsSaving(false);
          return;
        }

        let statusCategoryName =
          responseStatusInt.data.data.statusInteroperability;
        const transitions = responseJira.data.data;
        const transition = transitions.find(
          (trans: any) => trans.to.statusCategory.name === statusCategoryName,
        );
        console.log(id, transition);
        return;

        if (transition === undefined) {
          toast.error(t("Herramienta.no_compatible_jira_state"));
        } else if (transition.name === state) {
          toast.warning(t("Herramienta.state_already_synced"));
        } else {
          updateJiraState(id, transition);
        }
      } else {
        toast.error(t("Herramienta.jira_state_update_error"));
      }
    } catch (error) {
      toast.error(t("Herramienta.jira_state_update_error"));
    }

    setIsSaving(false);
  };

  /**
   * Funciones de Azure
   */

  const manajeAzureWorkItems = async (
    details: any,
    relations: any,
    idElementType: any,
    idProjectType: any,
  ) => {
    let filteredTasks: any = [];
    if (trueffortId !== -1) {
      const trueffortElems = await projectElementService.getByIdJiraProject(
        projectId,
        trueffortId,
      );
      //console.log("TRUEFFORT ELEMS AZURE", trueffortElems);
      filteredTasks = details.filter(
        (item: any) =>
          !isElmentInTrueffort(item.id + "", trueffortElems.data.data),
      );
      setSyncedElements(
        details
          .filter((item: any) =>
            isElmentInTrueffort(item.id + "", trueffortElems.data.data),
          )
          .map((workItem: any) => ({
            apiID: workItem.id,
            name: workItem.fullTitle,
            trueffortStatus: trueffortElems.data.data.find(
              (elem: any) => elem.idToolTask === workItem.id + "",
            ).projectElement.status,
            status: workItem.fields["System.State"],
            type: workItem.fields["System.WorkItemType"],
            sprints: workItem.fields["System.IterationPath"].split("\\").pop(),
          })),
      );
    } else {
      filteredTasks = details;
    }

    // @ts-ignore
    let sprintsFromTasksAux = [];
    filteredTasks.forEach((item: any) => {
      const sprintField = item.fields["System.IterationPath"];
      const sprintName = sprintField.split("\\").pop();
      // @ts-ignore
      if (!sprintsFromTasksAux.find((x) => x === sprintName)) {
        sprintsFromTasksAux.push(sprintName);
      }
    });
    // @ts-ignore
    setSprintsFromTasks(sprintsFromTasksAux);
    //console.log(filteredTasks);
    //console.log(elementTypes);
    let relDes: any = getRelationsAsObject(relations);
    let elements = filteredTasks.map((workItem: any) => ({
      apiID: workItem.id,
      name: workItem.fullTitle,
      idStatus: workItem.fields["System.State"],
      status: workItem.fields["System.State"],
      creationDate: workItem.fields["System.CreatedDate"],
      idElementType,
      estimatedDays: Math.ceil(
        Math.ceil(
          workItem.fields["Microsoft.VSTS.Scheduling.OriginalEstimate"] || 0,
        ) / 8,
      ),
      estimatedTime: parseFloat(
        (
          workItem.fields["Microsoft.VSTS.Scheduling.OriginalEstimate"] || 0
        ).toFixed(2),
      ),
      durationMax: 0,
      durationMin: 0,
      effortMin: 0,
      effortMax: 0,
      idSize: 2,
      idComplexity: 2,
      sprints: workItem.fields["System.IterationPath"].split("\\").pop(),
      assignedUser:
        relDes[workItem.fields["System.AssignedTo"]?.id]?.idUser || "",
      assignedUserToInter: workItem.fields["System.AssignedTo"]?.id || "",
      estimatedTimeTool: parseFloat(
        (
          workItem.fields["Microsoft.VSTS.Scheduling.OriginalEstimate"] || 0
        ).toFixed(2),
      ),
      trEffortSug: 0,
      trEffortMinSug: 0,
      trEffortMaxSug: 0,
      estimatedDaysTool: Math.ceil(
        Math.ceil(
          workItem.fields["Microsoft.VSTS.Scheduling.OriginalEstimate"] || 0,
        ) / 8,
      ),
      trDurationSug: 0,
      trDurationMinSug: 0,
      trDurationMaxSug: 0,
    }));

    if (idElementType != "" && idProjectType != "") {
      let esti_ = await getEstimate(
        idProjectType,
        elements.map((elem: any) => ({
          id: elem.idElementType,
          id_size: elem.idSize,
          id_complexity: elem.idComplexity,
        })),
        elements,
        false,
      );
      console.log(esti_);
      for (let i = 0; i < elements.length; i++) {
        let eleFind = esti_?.projectElements.find(
          (pe: any) => pe.apiID == elements[i].apiID,
        );
        elements[i] = {
          ...elements[i],
          trEffortSug: eleFind?.estimatedTime || 0,
          trEffortMinSug: eleFind?.effortMin || 0,
          trEffortMaxSug: eleFind?.effortMax || 0,
          trDurationSug: eleFind?.estimatedDays || 0,
          trDurationMinSug: eleFind?.durationMin || 0,
          trDurationMaxSug: eleFind?.durationMax || 0,
        };
      }
    }

    setProjectElements(elements);
    console.log(elements);
    //setTotalHours(elements.reduce((acc: number, elem: any) => acc + elem.estimatedTime, 0));

    let maxDuration = elements.reduce(
      (acc: number, elem: any) => acc + elem.estimatedDays,
      0,
    );
    let minDuration = elements.reduce(
      (acc: number, elem: any) =>
        acc < elem.estimatedDays ? elem.estimatedDays : acc,
      0,
    );
    /*setMaxEstimatedDays(maxDuration);
    setMinEstimatedDays(minDuration);*/
    setTotalDuration(Math.round((maxDuration + minDuration) / 2));
    setIsLoading(false); // Finalizar la carga, independientemente del resultado
    //setEstimationUpdateNeeded(false);
  };

  const getAzureProjectSprints = () => {
    infoAzureProjectsService
      .getBoardSprints(organizationDomain, token, projectId)
      .then(({ data: response }) => {
        //console.log("SP", response);
        if (Array.isArray(response.value)) {
          const mappedSprints = response.value.map((sprint: any) => ({
            id: sprint.id,
            name: sprint.name,
          }));
          //console.log("SPRINTS", mappedSprints);
          setSprints(mappedSprints); // Actualizar el estado con los sprints mapeados
        } else {
          console.log("No sprints found");
        }
      })
      .catch((error) => {
        console.error("Error fetching sprints", error);
      });
  };

  const updateAzureState = (id: number, newState: string) => {
    const datos = {
      workitemId: id,
      stateName: newState,
    };
    infoAzureProjectsService
      .updateWorkitemState(organizationDomain, token, projectId, datos)
      .then(({ data: response }) => {
        if (response.success) {
          fetchProjectTasks(
            organizationDomain,
            email,
            token,
            projectId,
            "",
            internallyRelatedUsers,
            idSelectedProjectType,
          );
          getProjectSprints();
          updateUserLists();

          toast.success(t("Herramienta.azure_state_updated"));
        } else {
          toast.error(t("Herramienta.azure_state_update_error"));
        }
      })
      .catch((error: any) => {
        toast.error(t("Herramienta.azure_state_update_error"));
      });
  };

  const syncAzureState = async (
    id: number,
    type: string,
    trueffortStatus: any,
    state: string,
  ) => {
    try {
      const response = await infoAzureProjectsService.getWorkitemsStates(
        organizationDomain,
        token,
        projectId,
        type,
      );

      if (response.data.success) {
        const states = response.data.data.value;

        switch (trueffortStatus.name) {
          case "Creada":
            const proposedState = states.filter(
              (estado: any) => estado.category === "Proposed",
            );

            if (proposedState.length === 0) {
              toast.error(t("Herramienta.no_compatible_azure_state"));
            } else if (
              proposedState.findIndex(
                (estado: any) => estado.name === state,
              ) === -1
            ) {
              updateAzureState(id, proposedState[0].name);
            } else {
              toast.warning(t("Herramienta.state_already_synced"));
            }

            break;

          case "En Proceso":
            const inProgressState = states.filter(
              (estado: any) => estado.category === "InProgress",
            );

            if (inProgressState.length === 0) {
              toast.error(t("Herramienta.no_compatible_azure_state"));
            } else if (
              inProgressState.findIndex(
                (estado: any) => estado.name === state,
              ) === -1
            ) {
              updateAzureState(id, inProgressState[0].name);
            } else {
              toast.warning(t("Herramienta.state_already_synced"));
            }

            break;

          case "Terminada":
            const completedState = states.filter(
              (estado: any) => estado.category === "Completed",
            );

            if (completedState.length === 0) {
              toast.error(t("Herramienta.no_compatible_azure_state"));
            } else if (
              completedState.findIndex(
                (estado: any) => estado.name === state,
              ) === -1
            ) {
              updateAzureState(id, completedState[0].name);
            } else {
              toast.warning(t("Herramienta.state_already_synced"));
            }

            break;

          case "Cancelada":
            const removedState = states.filter(
              (estado: any) => estado.category === "Removed",
            );

            if (removedState.length === 0) {
              toast.error(t("Herramienta.no_compatible_azure_state"));
            } else if (
              removedState.findIndex((estado: any) => estado.name === state) ===
              -1
            ) {
              updateAzureState(id, removedState[0].name);
            } else {
              toast.warning(t("Herramienta.state_already_synced"));
            }

            break;

          default:
            toast.error(t("Herramienta.no_compatible_azure_state"));
        }
      } else {
        toast.error(t("Herramienta.azure_state_update_error"));
      }
    } catch (error) {
      toast.error(t("Herramienta.azure_state_update_error"));
    }

    setIsSaving(false);
  };

  /**
   *
   * Funciones de estimación
   *
   */
  const adjustDurationEstimates = (
    projectElement: any,
    estimationElement: any,
  ) => {
    let durationMin: number = 0;
    let durationMax: number = 0;
    for (let i: number = 0; i < estimationElement.phasetypes.length; i++) {
      let phaseDurationMax: number = estimationElement.phasetypes[
        i
      ].tasktypes.reduce(
        (acc: number, tasktype: any) => acc + tasktype.duration_avg,
        0,
      );
      let phaseDurationMin: number = estimationElement.phasetypes[
        i
      ].tasktypes.reduce(
        (acc: number, tasktype: any) =>
          acc < tasktype.duration_avg ? tasktype.duration_avg : acc,
        0,
      );
      let phaseDurationAverage: number = Math.round(
        (phaseDurationMax + phaseDurationMin) / 2,
      );
      durationMax += phaseDurationAverage;
      durationMin =
        durationMin < phaseDurationAverage ? phaseDurationAverage : durationMin;
    }

    projectElement.estimatedDays = Math.round((durationMin + durationMax) / 2);
    projectElement.durationMax = durationMax;
    projectElement.durationMin = durationMin;
  };

  const validElementTypeSelected = () => {
    const missingElementTypes =
      projectElements.filter(
        (elem: any): boolean =>
          !isElementMappedToTerminada(elem) && elem.idElementType === "",
      ).length > 0;

    if (missingElementTypes) {
      toast.error(
        "Debes seleccionar un tipo de elemento para todos los elementos que serán guardados",
      );
    }

    return missingElementTypes;
  };

  const getEstimate = async (
    idProjectType: any,
    projectElementsTypes: any,
    projectElements_: any,
    applyChange: boolean,
  ) => {
    //if (validElementTypeSelected()) { return; }

    const elementTypesSet = new Set(projectElementsTypes.map(JSON.stringify));

    const datos = {
      project_types: [idProjectType],
      element_types: Array.from(elementTypesSet).map((elem: any) =>
        JSON.parse(elem),
      ),
    };

    //console.log("DATOS ESTIMACION", datos);

    // @ts-ignore
    let resp = await estimationsService.getAccumulatedEstimate(datos);
    if (resp.status == 200 && resp?.data?.status == "ok") {
      let response = resp?.data;
      const estimationResponse = response.projecttypes[0];
      //console.log(estimationResponse);
      const projectElementsCopy = JSON.parse(JSON.stringify(projectElements_));

      //console.log("ESTIMATION RESPONSE", estimationResponse);

      for (let i = 0; i < estimationResponse.elementtypes.length; i++) {
        for (
          let j = 0;
          j < estimationResponse.elementtypes[i].dificulties.length;
          j++
        ) {
          for (let k = 0; k < projectElementsCopy.length; k++) {
            if (
              projectElementsCopy[k].idElementType ==
                estimationResponse.elementtypes[i].id &&
              projectElementsCopy[k].idComplexity ==
                estimationResponse.elementtypes[i].dificulties[j]
                  .complexity_id &&
              projectElementsCopy[k].idSize ==
                estimationResponse.elementtypes[i].dificulties[j].size_id
            ) {
              projectElementsCopy[k].estimatedTime =
                estimationResponse.elementtypes[i].dificulties[j]?.effort_avg ||
                0;
              projectElementsCopy[k].effortMin =
                estimationResponse.elementtypes[i].dificulties[j]?.effort_min ||
                0;
              projectElementsCopy[k].effortMax =
                estimationResponse.elementtypes[i].dificulties[j]?.effort_max ||
                0;
              projectElementsCopy[k].estimatedDays =
                estimationResponse.elementtypes[i].dificulties[j]
                  ?.duration_avg || 0;
              projectElementsCopy[k].durationMax =
                estimationResponse.elementtypes[i].dificulties[j]
                  ?.duration_max || 0;
              projectElementsCopy[k].durationMin =
                estimationResponse.elementtypes[i].dificulties[j]
                  ?.duration_min || 0;
              if (applyChange) {
                adjustDurationEstimates(
                  projectElementsCopy[i],
                  estimationResponse.elementtypes[i].dificulties[j],
                );
              }
            }
          }
        }
      }

      let minDuration = projectElementsCopy.reduce(
        (acc: number, element: any): boolean =>
          acc < element.estimatedDays ? element.estimatedDays : acc,
        0,
      );
      let maxDuration = projectElementsCopy.reduce(
        (acc: number, element: any): number => acc + element.estimatedDays,
        0,
      );
      //console.log(JSON.stringify(projectElementsCopy));
      if (applyChange) {
        setTotalDuration(Math.round((maxDuration + minDuration) / 2));
        setProjectElements(projectElementsCopy);
        setEstimation(estimationResponse);
      }
      return {
        totalDuration: Math.round((maxDuration + minDuration) / 2),
        projectElements: projectElementsCopy,
        estimation: estimationResponse,
      };
    } else {
      console.log("ERROR ESTIMACION", t(resp?.data?.code));
      toast.error(
        "Ocurrió un problema al ejecutar la estimación (" +
          t(resp?.data?.code) +
          ")",
      );
    }
  };

  const getRowsByElementType = () => {
    const elementsToSave = projectElements.filter(
      (elem: any) => !isElementMappedToTerminada(elem),
    );

    let rowsByElementType = elementsToSave.reduce((acc: any, row: any) => {
      const elementTypeId = row.idElementType;

      if (!acc[elementTypeId]) {
        acc[elementTypeId] = [];
      }

      acc[elementTypeId].push(row);
      return acc;
    }, {});

    return rowsByElementType;
  };

  const getEstructureRows = (rows: any) => {
    return Object.entries(rows).map(([elementTypeId, rows]: any[]) => ({
      idElementType: parseInt(elementTypeId),
      projectElements: rows,
    }));
  };

  const getProjectPhasesInter = (elemType: any, elemTypeData: any) => {
  const dedicatedTime = Number(elemTypeData.dedicatedTime) || 0;

  return elemType.phaseTypes.map((pt: any, phaseIndex: number) => {
    return {
      idPhaseType: pt.idPhase,
      estimatedDays: elemTypeData.estimatedDays,
      estimatedTime: elemTypeData.estimatedTime,
      dedicatedTime: phaseIndex === 0 ? dedicatedTime : 0,
      projectTasks: pt.taskTypes.map((taskType: any, taskIndex: number) => ({
        idTaskType: taskType.idTaskType,
        estimatedTime: elemTypeData.estimatedTime,
        estimatedDays: elemTypeData.estimatedDays,
        dedicatedTime:
          phaseIndex === 0 && taskIndex === 0 ? dedicatedTime : 0,
        assignedUsers:
          elemTypeData.assignedUser != "" ? [elemTypeData.assignedUser] : [],
      })),
    };
  });
};

  const ceroValuesNotification = (dataToSave: any) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <TrueffortConfirmAlert
            title={
              <Typography
                color="#6A6A6A"
                variant="h6"
                fontWeight={700}
                marginBottom="20px"
              >
                <InfoIcon sx={{ color: "#6A6A6A" }} />
                &nbsp;&nbsp;{t("Warning")}
              </Typography>
            }
            alertColor="darkG"
            message={t("estimation_page.cero_estimates")}
            buttons={[
              {
                label: t("Cancel"),
                onClick: () => {
                  setIsSaving(false);
                  onClose();
                },
              },
              {
                label: t("accept"),
                onClick: () => {
                  onClose();
                  submitProjectPlan(dataToSave);
                },
              },
            ]}
          />
        );
      },
    });
  };

  const searchForCeroValues = (data: any) => {
    let containsZero = 0;
    for (let obj of data?.elementTypes) {
      for (let pe of obj.projectElements) {
        containsZero += pe.estimatedTime == 0 ? 1 : 0;
        for (let pp of pe.projectPhases) {
          containsZero += pp.estimatedTime == 0 ? 1 : 0;
          for (let pt of pp.projectTasks) {
            containsZero += pt.estimatedTime == 0 ? 1 : 0;
          }
        }
      }
    }

    return containsZero;
  };

  const getUnmappedStatuses = () => {
    const mappedStatusIds = new Set(
      relationsStatuses.flatMap((trueffortStatus: any) =>
        trueffortStatus.statusTool.map((statusTool: any) =>
          String(statusTool.id),
        ),
      ),
    );

    const unmappedStatusesMap = new Map();

    statusesProject.forEach((status: any) => {
      const statusId = String(status.id);

      if (!mappedStatusIds.has(statusId)) {
        unmappedStatusesMap.set(statusId, status.name);
      }
    });

    return Array.from(unmappedStatusesMap.values());
  };

  const handleSaveButtonClick = () => {
    if (validElementTypeSelected()) {
      return;
    }

    const unmappedStatuses = getUnmappedStatuses();
    console.log("Unmapped Statuses:", unmappedStatuses);

    if (unmappedStatuses.length > 0) {
      toast.warning(
        unmappedStatuses.length === 1
          ? `El estatus "${unmappedStatuses[0]}" no está mapeado con ningún estatus de Trueffort`
          : `Los estatus "${unmappedStatuses.join(", ")}" no están mapeados con ningún estatus de Trueffort`,
      );
      return;
    }

    setIsSaving(true); // Actualizar el estado isSaving a true
    // Agrupar las filas por tipo de elemento
    const rowsByElementType = getRowsByElementType();
    //console.log(rowsByElementType);
    // Crear un objeto elementTypes para cada grupo
    const elementTypesData = getEstructureRows(rowsByElementType);

    //console.log(estimation);
    //console.log(selectedProjectType);
    if (["1", "4"].includes(idSelectedEstimationType)) {
      for (let i: number = 0; i < elementTypesData.length; i++) {
        //console.log(elementTypesData[i]);
        const et = selectedProjectType.elementTypeList.find(
          (etObj: any) =>
            etObj.idElementType == elementTypesData[i].idElementType,
        );
        for (
          let j: number = 0;
          j < elementTypesData[i].projectElements.length;
          j++
        ) {
          //console.log(elementTypesData[i].projectElements[j]);
          elementTypesData[i].projectElements[j].projectPhases =
            getProjectPhasesInter(et, elementTypesData[i].projectElements[j]);
        }
      }
    } else {
      for (let i: number = 0; i < elementTypesData.length; i++) {
        for (
          let j: number = 0;
          j < elementTypesData[i].projectElements.length;
          j++
        ) {
          const foundElementType = estimation.elementtypes.find(
            (elemType: any) =>
              elemType.id === elementTypesData[i].idElementType,
          );
          const foundElementTypeDifficulty = foundElementType.dificulties.find(
            (elemInfo: any) =>
              elemInfo.size_id ===
                elementTypesData[i].projectElements[j].idSize &&
              elemInfo.complexity_id ===
                elementTypesData[i].projectElements[j].idComplexity,
          );
          if (
            foundElementTypeDifficulty &&
            foundElementTypeDifficulty.phasetypes
          ) {
            elementTypesData[i].projectElements[j].projectPhases =
              foundElementTypeDifficulty.phasetypes.map(
                (phase: any, index: number) => {
                  //Obtiene la sumatoria de las medias de duracion, tareas en paralelo
                  let durationMax: number = phase.tasktypes.reduce(
                    (acc: number, tasktype: any) => acc + tasktype.duration_avg,
                    0,
                  );
                  //Obtiene la duracion mas grande de las tareas
                  let durationMin: number = Math.max(
                    ...phase.tasktypes.map((tt: any) => tt.duration_avg),
                  );

                  let effort: number = Math.floor(
                    elementTypesData[i].projectElements[j].estimatedTime /
                      foundElementTypeDifficulty.phasetypes.length,
                  );
                  if (index === 0) {
                    effort +=
                      elementTypesData[i].projectElements[j].estimatedTime %
                      foundElementTypeDifficulty.phasetypes.length;
                  }

                  return {
                    idPhaseType: phase.id,
                    estimatedDays: Math.round((durationMin + durationMax) / 2),
                    estimatedTime: effort,
                    projectTasks: phase.tasktypes.map(
                      (taskType: any, taskIndex: number) => ({
                        idTaskType: taskType.id,
                        estimatedTime:
                          taskIndex === 0
                            ? Math.floor(effort / phase.tasktypes.length) +
                              (effort % phase.tasktypes.length)
                            : Math.floor(effort / phase.tasktypes.length),
                        estimatedDays: taskType.duration_avg,
                        assignedUsers: projectElements.find(
                          (element: any) =>
                            element.apiID ===
                            elementTypesData[i].projectElements[j].apiID,
                        )?.assignedUser
                          ? [
                              projectElements.find(
                                (element: any) =>
                                  element.apiID ===
                                  elementTypesData[i].projectElements[j].apiID,
                              ).assignedUser,
                            ]
                          : [],
                      }),
                    ),
                  };
                },
              );
          } else {
            console.error(
              `Element type with id ${elementTypesData[i].idElementType} not found or has no phaseTypes`,
            );
          }
        }
      }
    }

    //console.log(elementTypesData);
    //return;
    // Asignación de los datos para guardar en el proyecto General
    const dataToSave = {
      idProjectType: idSelectedProjectType,
      name: projectName,
      //jiraKey: projectKey,
      //toolName: "JIRA",
      toolId: selectedAPI == TOOLS_EXTERNAL_NAME.jira ? 1 : 2,
      toolDomain: organizationDomain,
      toolProjectId: projectId,
      idEstimationType: idSelectedEstimationType,
      statusFromTrue: managedState,
      idsLeader: [],
      idMeasurementStandard: null,
      estimatedDays: totalDuration,
      estimatedTime: totalHours,
      elementTypes: elementTypesData,
    };

    //console.log(dataToSave);
    let bandera = false;
    bandera =
      dataToSave.elementTypes.filter(
        (e: any) =>
          e.idElementType == undefined ||
          e.idElementType == null ||
          isNaN(e.idElementType),
      ).length > 0;
    if (bandera) {
      toast.error(
        "Debes seleccionar un tipo de elemento para todos los elementos",
      );
      setIsSaving(false);
      return;
    }

    if (searchForCeroValues(dataToSave) > 0) {
      ceroValuesNotification(dataToSave);
    } else {
      submitProjectPlan(dataToSave);
    }
  };

  const buildStatusRelations = (idProjectInteroperability: number) => {
    const map = new Map<string, any>();

    relationsStatuses.forEach((el: any) => {
      el.statusTool.forEach((st: any) => {
        const key = `${idProjectInteroperability}-${String(st.id)}`;

        map.set(key, {
          idProjectInteroperability,
          idStatus: el.id,
          idStatusInteroperability: String(st.id),
        });
      });
    });

    return Array.from(map.values());
  };
  const submitProjectPlan = async (dataToSave: any) => {
    console.log(dataToSave);
    console.log(relationsStatuses);
    let copyDataToSave = JSON.parse(JSON.stringify(dataToSave));
    for (let i = 0; i < copyDataToSave.elementTypes.length; i++) {
      for (
        let j = 0;
        j < copyDataToSave.elementTypes[i].projectElements.length;
        j++
      ) {
        for (let k = 0; k < relationsStatuses.length; k++) {
          let inc = relationsStatuses[k]?.statusTool
            .map((st: any) => st.name)
            .includes(copyDataToSave.elementTypes[i].projectElements[j].status);
          if (inc) {
            copyDataToSave.elementTypes[i].projectElements[j].idStatus =
              relationsStatuses[k].id;
            break;
          }
        }
      }
    }
    console.log(copyDataToSave);
    //return;
    let resp = await interoperabilityService.updateRelatedUsers(
      relationshipUserTool
        .filter((rut: any) => rut.idUser && rut.id)
        .map((rut: any) => {
          return {
            idUser: rut.idUser,
            idToolUser: rut.id,
            idTool: selectedAPI == TOOLS_EXTERNAL_NAME.jira ? 1 : 2,
          };
        }),
    );
    if (!resp?.data?.success) {
      toast.error("Ocurrió un error al relacionar los usuarios");
      return;
    }

    // Crear una instancia del servicio de proyecto
    const projectService = new ProjectService();
    // Guardar los datos a través de la API

    if (trueffortId !== -1) {
      projectService
        .updatePlan(trueffortId, copyDataToSave)
        .then(async ({ data: response }) => {
          console.log("RESPONSE UPDATE", response);
          if (
            response.internalError != null &&
            response.internalError &&
            response.message != null
          ) {
            toast.error(response.message);
            return;
          }

          const listRelsStatus = buildStatusRelations(
            response.data.idProjectInteroperability,
          );

          const statusResponse =
            await interoperabilityService.relatedStatusesByProject(
              listRelsStatus,
            );

          if (!statusResponse?.data?.success) {
            toast.error(
              "El proyecto se actualizó, pero ocurrió un error al guardar los estatus relacionados",
            );
            return;
          }

          toast.success(t("estimation_page.msg_success_save"), {
            onClose: () =>
              window.location.replace(
                "/projectDetail?idProject=" + response.data.idProject,
              ),
          });
        })
        .catch((error) => {
          console.log(error);
          toast.error("Ocurrió un error al enviar los datos al back-end.");
        })
        .finally(() => {
          setIsSaving(false);
        });
    } else {
      projectService
        .createPlan(copyDataToSave)
        .then(({ data: response }) => {
          // Manejar la respuesta de la API
          if (
            response.internalError != null &&
            response.internalError &&
            response.message != null
          ) {
            toast.error(response.message);
          } else {
            let listRelsStatus: any = [];
            relationsStatuses.forEach((el: any) => {
              el.statusTool.forEach((st: any) => {
                listRelsStatus.push({
                  idProjectInteroperability:
                    response.data.idProjectInteroperability,
                  idStatus: el.id,
                  idStatusInteroperability: st.id,
                });
              });
            });
            if (trueffortId == -1) {
              interoperabilityService
                .relatedStatusesByProject(listRelsStatus)
                .then((res: any) => {
                  if (res.data.success) {
                    // Si no hay errores, mostrar un mensaje de éxito y redirigir a la página de detalles del proyecto
                    toast.success(t("estimation_page.msg_success_save"), {
                      onClose: () =>
                        window.location.replace(
                          "/projectDetail?idProject=" + response.data.idProject,
                        ),
                    });
                  }
                });
            } else {
              toast.success(t("estimation_page.msg_success_save"), {
                onClose: () =>
                  window.location.replace(
                    "/projectDetail?idProject=" + response.data.idProject,
                  ),
              });
            }
          }
        })
        .catch((error) => {
          // Manejar errores de la API
          toast.error("Ocurrió un error al enviar los datos al back-end.");
        })
        .finally(() => {
          setIsSaving(false);
        });
    }
  };

  const handleDeleteElement = (elemId: string | number) => {
    const updatedProjectElements = projectElements.filter(
      (elem: any) => String(elem.apiID) !== String(elemId),
    );

    setProjectElements(updatedProjectElements);
    recalculateTotalDuration(updatedProjectElements);

    setSelectedElementIdsToDelete((prev: string[]) =>
      prev.filter((id) => id !== String(elemId)),
    );
  };

  const recalculateTotalDuration = (elements: any[]) => {
    const maxDuration = elements.reduce(
      (acc: number, elem: any) => acc + elem.estimatedDays,
      0,
    );

    const minDuration = elements.reduce(
      (acc: number, elem: any) =>
        acc < elem.estimatedDays ? elem.estimatedDays : acc,
      0,
    );

    setTotalDuration(Math.round((maxDuration + minDuration) / 2));
  };

  const handleToggleElementToDelete = (elemId: string | number) => {
    const elem = projectElements.find(
      (projectElement: any) => String(projectElement.apiID) === String(elemId),
    );

    if (!elem || isElementMappedToTerminada(elem)) {
      return;
    }

    const id = String(elemId);

    setSelectedElementIdsToDelete((prev: string[]) =>
      prev.includes(id)
        ? prev.filter((selectedId) => selectedId !== id)
        : [...prev, id],
    );
  };

  const handleSelectAllVisibleElements = () => {
    const visibleIds = filteredElements
      .filter((elem: any) => !isElementMappedToTerminada(elem))
      .map((elem: any) => String(elem.apiID));

    setSelectedElementIdsToDelete((prev: string[]) => {
      const selectedIds = new Set(prev);

      visibleIds.forEach((id: string) => {
        selectedIds.add(id);
      });

      return Array.from(selectedIds);
    });
  };

  const handleClearSelectedElements = () => {
    setSelectedElementIdsToDelete([]);
  };

  const handleDeleteSelectedElements = () => {
    if (selectedElementIdsToDelete.length === 0) {
      toast.warning("Selecciona al menos un elemento para borrar");
      return;
    }

    const idsToDelete = new Set(
      selectedElementIdsToDelete.filter((id: string) => {
        const elem = projectElements.find(
          (projectElement: any) => String(projectElement.apiID) === String(id),
        );

        return elem && !isElementMappedToTerminada(elem);
      }),
    );

    const updatedProjectElements = projectElements.filter(
      (elem: any) => !idsToDelete.has(String(elem.apiID)),
    );

    setProjectElements(updatedProjectElements);
    recalculateTotalDuration(updatedProjectElements);
    setSelectedElementIdsToDelete([]);

    toast.success("Elementos eliminados de la sincronización");
  };

  const handleElementTypeChange = (elemID: string, idElementType: number) => {
    let elem = projectElements.find((pe: any) => pe.apiID == elemID);
    const projectElementsCopy = projectElements.map((elem: any) =>
      elem.apiID === elemID
        ? { ...elem, idElementType: idElementType }
        : { ...elem },
    );

    setProjectElements(projectElementsCopy);
    if (["2", "3"].includes(idSelectedEstimationType)) {
      //setEstimationUpdateNeeded(true);
      getEstimate(
        idSelectedProjectType,
        [
          {
            id: idElementType,
            id_size: elem.idSize,
            id_complexity: elem.idComplexity,
          },
        ],
        projectElementsCopy,
        true,
      );
    }
  };

  const handleElementSizeChange = (elemID: string, idSize: number) => {
    let elem = projectElements.find((pe: any) => pe.apiID == elemID);
    const projectElementsCopy = projectElements.map((elem: any) =>
      elem.apiID === elemID ? { ...elem, idSize: idSize } : { ...elem },
    );

    setProjectElements(projectElementsCopy);
    if (["2", "3"].includes(idSelectedEstimationType)) {
      getEstimate(
        idSelectedProjectType,
        [
          {
            id: elem.idElementType,
            id_size: idSize,
            id_complexity: elem.idComplexity,
          },
        ],
        projectElementsCopy,
        true,
      );
    }
    //setEstimationUpdateNeeded(true);
  };

  const handleElementComplexityChange = (
    elemID: string,
    idComplexity: number,
  ) => {
    let elem = projectElements.find((pe: any) => pe.apiID == elemID);
    const projectElementsCopy = projectElements.map((elem: any) =>
      elem.apiID === elemID
        ? { ...elem, idComplexity: idComplexity }
        : { ...elem },
    );

    setProjectElements(projectElementsCopy);
    if (["2", "3"].includes(idSelectedEstimationType)) {
      getEstimate(
        idSelectedProjectType,
        [
          {
            id: elem.idElementType,
            id_size: elem.idSize,
            id_complexity: idComplexity,
          },
        ],
        projectElementsCopy,
        true,
      );
    }
    //setEstimationUpdateNeeded(true);
  };

  const handleElementEffortChange = (
    elemID: string,
    effort: number,
    previousValue: number,
  ) => {
    const projectElementsCopy = projectElements.map((elem: any) =>
      elem.apiID === elemID ? { ...elem, estimatedTime: effort } : { ...elem },
    );

    setProjectElements(projectElementsCopy);
  };

  const handleElementDurationChange = (elemID: number, duration: number) => {
    const projectElementsCopy = projectElements.map((elem: any) =>
      elem.apiID === elemID
        ? { ...elem, estimatedDays: duration }
        : { ...elem },
    );

    setProjectElements(projectElementsCopy);
    let minDuration = projectElementsCopy.reduce(
      (acc: number, elem: any) =>
        acc < elem.estimatedDays ? elem.estimatedDays : acc,
      0,
    );
    let maxDuration = projectElementsCopy.reduce(
      (acc: number, elem: any) => acc + elem.estimatedDays,
      0,
    );

    if (duration > totalDuration) {
      setTotalDuration(duration > maxDuration ? maxDuration : duration);
    }
    setTotalDuration(Math.round((maxDuration + minDuration) / 2));
  };

  const handleTotalDurationInputChange = (newTotalDuration: number) => {
    /*if (newTotalDuration < minEstimatedDays || newTotalDuration < 0 || newTotalDuration > maxEstimatedDays) {
      return;
    }*/
    if (newTotalDuration > maxEstimatedDays) {
      setTotalDuration((maxEstimatedDays + minEstimatedDays) / 2);
    } else {
      validateDurationInput(newTotalDuration);
      setTotalDuration(newTotalDuration);
    }
  };

  const validateDurationInput = (durationInput: number) => {
    if (isNaN(durationInput) || !Number.isInteger(durationInput)) {
      setDurationInputErrorMessage("Sólo valores númericos enteros");
    } else if (durationInput < minEstimatedDays) {
      setDurationInputErrorMessage("Valor menor que el mínimo");
    } else if (durationInput < 0) {
      setDurationInputErrorMessage("Valores negativos inválidos");
    } else if (durationInput > maxEstimatedDays) {
      setDurationInputErrorMessage("Valor mayor que el máximo");
    } else if (durationInputErrorMessage !== "") {
      setDurationInputErrorMessage("");
    }
  };

  const handleClickMenu = (event: any, value: any) => {
    setAnchorElemFilter(event.currentTarget);
    setMenuNumber(value);
  };

  const getButtonEstimate = () => {
    //console.log(estimationUpdateNeeded);
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
          marginBottom: "10px",
          marginRight: "10px",
        }}
      >
        {/* Botón de guardado */}
        <TrueffortButton
          variant="contained"
          color="primary"
          onClick={() => {
            handleSaveButtonClick();
          }}
          disabled={
            isSaving ||
            projectElements.length === 0 ||
            durationInputErrorMessage !== ""
          }
        >
          {t("Herramienta.save")}
        </TrueffortButton>
      </Box>
    );
  };

  const getContainer = (title: string, children: any) => {
    return (
      <Grid item xs>
        <Card elevation={1} sx={{ height: "100%" }}>
          <CardContent>
            <Grid
              container
              spacing={1}
              direction="column"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs>
                <Typography color="#050536">{title}</Typography>
              </Grid>
              {children}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    );
  };

  const [activeHelperDialogIndex, setActiveHelperDialogIndex] = useState(-1);

  const handleOpenHelp = () => {
    setActiveHelperDialogIndex(0);
  };

  const handleClose = () => {
    setActiveHelperDialogIndex(-1);
  };

  const handleActiveHelperChange = () => {
    if (
      activeHelperDialogIndex ===
      helperDialogs["estimationInteroperability"].length
    ) {
      setActiveHelperDialogIndex(-1);
    } else {
      setActiveHelperDialogIndex((prev: number) => prev + 1);
    }
  };

  const [managedState, setManagedState]: any = useState(true);

  //console.log(projectElements);

  // Número de columnas
  const numberOfColumns = 9;
  return (
    <SiteWrapper>
      <HelperDialog
        title={t(helperDialogs["estimationInteroperability"][0].title)}
        body={t(helperDialogs["estimationInteroperability"][0].body)}
        dialogIndex={0}
        totalDialogs={8}
        handleNext={handleActiveHelperChange}
        isOpen={activeHelperDialogIndex === 0}
        handleClose={handleClose}
      >
        <Container maxWidth="xl" sx={{ marginTop: "20px", minWidth: "1280px" }}>
          <Typography color="#4A4A4A" variant="h4">
            {projectName}
            <IconButton onClick={handleOpenHelp}>
              <HelpIcon sx={{ color: "#6875C7" }} />
            </IconButton>
          </Typography>
        </Container>
      </HelperDialog>

      <Container maxWidth="xl" sx={{ marginTop: "20px" }}>
        <Paper
          elevation={0}
          square
          sx={{ padding: "6px", bgcolor: "#F5F5F5", minWidth: "1280px" }} // Ajustar marginLeft aquí
        >
          <Typography color="#4A4A4A" variant="h6">
            <SettingsIcon /> {t("Herramienta.config")}
          </Typography>
          {isLoading ? (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              style={{ minHeight: "200px" }}
            >
              <CircularProgress />
            </Grid>
          ) : (
            <Grid container spacing={1}>
              <HelperDialog
                title={t(helperDialogs["estimationInteroperability"][1].title)}
                body={t(helperDialogs["estimationInteroperability"][1].body)}
                dialogIndex={1}
                totalDialogs={8}
                handleNext={handleActiveHelperChange}
                isOpen={activeHelperDialogIndex === 1}
                handleClose={handleClose}
              >
                <Grid
                  item
                  xl={6}
                  style={{
                    minHeight:
                      relationshipUserTool.length == 0 ? "9em" : "100%",
                  }}
                >
                  <RelatedUsers
                    users={users}
                    setRelations={setRelationshipUserTool}
                    relations={relationshipUserTool}
                    api={selectedAPI}
                  />
                </Grid>
              </HelperDialog>
              <HelperDialog
                title={t(helperDialogs["estimationInteroperability"][2].title)}
                body={t(helperDialogs["estimationInteroperability"][2].body)}
                dialogIndex={2}
                totalDialogs={8}
                handleNext={handleActiveHelperChange}
                isOpen={activeHelperDialogIndex === 2}
                handleClose={handleClose}
              >
                <Grid item xl={6}>
                  <RelatedStatus
                    statusTool={statusesProject}
                    setRelations={setRelationsStatuses}
                    relations={relationsStatuses}
                    api={selectedAPI}
                    managedState={managedState}
                    setManagedState={setManagedState}
                  />
                </Grid>
              </HelperDialog>
              <HelperDialog
                title={t(helperDialogs["estimationInteroperability"][3].title)}
                body={t(helperDialogs["estimationInteroperability"][3].body)}
                dialogIndex={3}
                totalDialogs={8}
                handleNext={handleActiveHelperChange}
                isOpen={activeHelperDialogIndex === 3}
                handleClose={handleClose}
              >
                <Grid item xl={12}>
                  <Card elevation={2}>
                    <CardContent>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography variant="h5" color="#050536">
                            {t("Herramienta.type_project")}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                          {/* Selector de tipo de proyecto */}
                          <Select
                            id="project-type-select"
                            name="Project"
                            size="small"
                            sx={{
                              backgroundColor: "#F5F5F5",
                              color: "#07074E",
                            }}
                            IconComponent={KeyboardArrowDown}
                            displayEmpty
                            fullWidth
                            value={idSelectedProjectType}
                            onChange={(e) =>
                              handleChangeProjectTypeSelect(e.target.value)
                            }
                          >
                            <MenuItem value="" disabled>
                              {t("Select")}
                            </MenuItem>
                            {/* Mapeo de tipos de proyecto */}
                            {projectTypes.map((pro: any, k: any) => (
                              <MenuItem
                                key={pro.idProjectType}
                                value={pro.idProjectType}
                                className={pro.active == 1 ? "" : "inactive"}
                              >
                                {pro.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </HelperDialog>
            </Grid>
          )}
        </Paper>
      </Container>

      {/* Contenedor para la tabla y los detalles del proyecto seleccionado */}
      <Container maxWidth="xl" sx={{ marginTop: "20px" }}>
        <Paper
          elevation={0}
          sx={{ padding: "6px", bgcolor: "#F5F5F5", minWidth: "1280px" }} // Ajustar marginLeft aquí
        >
          <Card elevation={1}>
            <CardContent>
              {isLoading ? (
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  style={{ minHeight: "200px" }}
                >
                  <CircularProgress />
                </Grid>
              ) : (
                /* Verifica si hay un proyecto seleccionado */
                selectedProjectType?.active && (
                  <>
                    <Grid item xs={12}>
                      <Paper
                        variant="outlined"
                        square
                        sx={{ padding: "10px", backgroundColor: "#F5F5F5" }}
                      >
                        <Stack direction="row" spacing={2}>
                          <Typography
                            sx={{ display: "flex", alignItems: "center" }}
                            color="#4A4A4A"
                          >
                            <DashboardIcon
                              fontSize="small"
                              sx={{ marginRight: "6px" }}
                            />
                            {t("project_tasks_page.title") + ": " + projectName}
                          </Typography>

                          <Typography
                            sx={{ display: "flex", alignItems: "center" }}
                            color="#4A4A4A"
                          >
                            <AppRegistrationIcon
                              fontSize="small"
                              sx={{ marginRight: "6px" }}
                            />
                            {t("project_page.template") +
                              ": " +
                              selectedProjectType.name}
                          </Typography>
                        </Stack>
                      </Paper>
                      <Grid
                        container
                        direction="row"
                        alignItems="stretch"
                        spacing={1}
                      >
                        <HelperDialog
                          title={t(
                            helperDialogs["estimationInteroperability"][4]
                              .title,
                          )}
                          body={t(
                            helperDialogs["estimationInteroperability"][4].body,
                          )}
                          dialogIndex={4}
                          totalDialogs={8}
                          handleNext={handleActiveHelperChange}
                          isOpen={activeHelperDialogIndex === 4}
                          handleClose={handleClose}
                        >
                          {getContainer(
                            t("estimation_page.estimated_total_effort"),
                            <Grid item xs>
                              <Stack
                                direction="row"
                                spacing={1}
                                justifyContent="center"
                                alignContent="center"
                              >
                                <Typography variant="h5" color="#000000">
                                  {formatSeconds(
                                    totalHours * 3600,
                                    false,
                                    false,
                                    false,
                                  )}
                                </Typography>

                                <Typography variant="h6" color="#000000">
                                  {t("estimation_page.man_hours")}
                                </Typography>
                              </Stack>
                            </Grid>,
                          )}
                        </HelperDialog>
                        <HelperDialog
                          title={t(
                            helperDialogs["estimationInteroperability"][5]
                              .title,
                          )}
                          body={t(
                            helperDialogs["estimationInteroperability"][5].body,
                          )}
                          dialogIndex={5}
                          totalDialogs={8}
                          handleNext={handleActiveHelperChange}
                          isOpen={activeHelperDialogIndex === 5}
                          handleClose={handleClose}
                        >
                          {getContainer(
                            t("estimation_page.estimated_total_time"),
                            <>
                              <Grid item xs>
                                <Stack
                                  direction="row"
                                  spacing={1}
                                  justifyContent="center"
                                  alignContent="center"
                                >
                                  <Limit
                                    isMax={false}
                                    label={minEstimatedDays}
                                    disabled={false}
                                    total={totalDuration}
                                    estimatedVal={minEstimatedDays}
                                    handle={handleTotalDurationInputChange}
                                  />
                                  <Stack
                                    direction="row"
                                    spacing={1}
                                    alignItems="flex-end"
                                    justifyContent="center"
                                  >
                                    <TextField
                                      type="number"
                                      size="small"
                                      InputProps={{
                                        inputProps: {
                                          min: minEstimatedDays,
                                          style: {
                                            height: "1.15rem",
                                            width: "100px",
                                            fontFamily:
                                              "ofelia-display, sans-serif",
                                            fontSize: "1.500rem",
                                          },
                                        },
                                      }}
                                      value={totalDuration}
                                      onChange={(e: any) =>
                                        handleTotalDurationInputChange(
                                          Number(e.target.value),
                                        )
                                      }
                                      error={durationInputErrorMessage !== ""}
                                      helperText={durationInputErrorMessage}
                                      disabled={false}
                                    />
                                    <Typography variant="h6" color="#000000">
                                      {t("estimation_page.days")}
                                    </Typography>
                                  </Stack>

                                  <Limit
                                    isMax={true}
                                    label={maxEstimatedDays}
                                    disabled={false}
                                    total={totalDuration}
                                    estimatedVal={maxEstimatedDays}
                                    handle={handleTotalDurationInputChange}
                                  />
                                </Stack>
                              </Grid>
                            </>,
                          )}
                        </HelperDialog>
                        <HelperDialog
                          title={t(
                            helperDialogs["estimationInteroperability"][6]
                              .title,
                          )}
                          body={t(
                            helperDialogs["estimationInteroperability"][6].body,
                          )}
                          dialogIndex={6}
                          totalDialogs={8}
                          handleNext={handleActiveHelperChange}
                          isOpen={activeHelperDialogIndex === 6}
                          handleClose={handleClose}
                        >
                          {getContainer(
                            t("Herramienta.selected_estimation_type"),
                            <Grid xs={12}>
                              <Select
                                id="project-type-select"
                                name="Project"
                                size="small"
                                sx={{
                                  backgroundColor: "#F5F5F5",
                                  color: "#07074E",
                                }}
                                IconComponent={KeyboardArrowDown}
                                fullWidth
                                value={idSelectedEstimationType}
                                onChange={(e) =>
                                  handleChangeEstimationType(e.target.value)
                                }
                              >
                                {selectedAPI == TOOLS_EXTERNAL_NAME.jira && (
                                  <MenuItem value="1">
                                    {"Herramienta Jira"}
                                  </MenuItem>
                                )}
                                {selectedAPI == TOOLS_EXTERNAL_NAME.azure && (
                                  <MenuItem value="4">
                                    {"Herramienta Azure"}
                                  </MenuItem>
                                )}
                                <MenuItem value="2">
                                  {"Trueffort (Por default)"}
                                </MenuItem>
                                {false && (
                                  <MenuItem value="3">
                                    {"Trueffort (Estadistico)"}
                                  </MenuItem>
                                )}
                              </Select>
                            </Grid>,
                          )}
                        </HelperDialog>
                      </Grid>
                    </Grid>

                    <Grid container>
                      <Grid item xs={2} sx={{ padding: 2, paddingRight: 1 }}>
                        <TrueffortNavButton
                          id="idSelectedStatuses"
                          size="small"
                          fullWidth
                          color={"primary"}
                          variant="contained"
                          onClick={(event: any) => handleClickMenu(event, 1)}
                        >
                          <CustomIconTrueffortScreen
                            icon={<CheckCircleIcon />}
                          />
                          {selectedStatuses.length == 0
                            ? t("reports_page.general.estatus")
                            : selectedStatuses.map(
                                (u: any, i: number) =>
                                  u.name +
                                  (i < selectedStatuses.length - 1 ? ", " : ""),
                              )}
                          <CustomIconTrueffortScreen
                            icon={<KeyboardArrowDownIcon />}
                          />
                        </TrueffortNavButton>
                      </Grid>
                      <Grid item xs={2} sx={{ padding: 2, paddingLeft: 1 }}>
                        {sprints.length > 0 && (
                          <TrueffortNavButton
                            id="idSelectedSprints"
                            size="small"
                            fullWidth
                            color={"primary"}
                            variant="contained"
                            onClick={(event: any) => handleClickMenu(event, 2)}
                          >
                            <CustomIconTrueffortScreen
                              icon={<CheckCircleIcon />}
                            />
                            {selectedSprints.length === 0
                              ? "Sprints"
                              : selectedSprints.map(
                                  (u: any, i: number) =>
                                    u +
                                    (i < selectedSprints.length - 1
                                      ? ", "
                                      : ""),
                                )}
                            <CustomIconTrueffortScreen
                              icon={<KeyboardArrowDownIcon />}
                            />
                          </TrueffortNavButton>
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={8}
                        style={{ display: "flex", justifyContent: "end" }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: "10px",
                            marginTop: "20px",
                            marginBottom: "10px",
                            marginRight: "10px",
                          }}
                        >
                          <TrueffortButton
                            variant="outlined"
                            color="primary"
                            onClick={handleSelectAllVisibleElements}
                            disabled={filteredElements.length === 0}
                          >
                            Seleccionar todo
                          </TrueffortButton>

                          <TrueffortButton
                            variant="outlined"
                            color="primary"
                            onClick={handleClearSelectedElements}
                            disabled={selectedElementIdsToDelete.length === 0}
                          >
                            Limpiar
                          </TrueffortButton>

                          <TrueffortButton
                            variant="contained"
                            color="primary"
                            onClick={handleDeleteSelectedElements}
                            disabled={selectedElementIdsToDelete.length === 0}
                          >
                            Borrar seleccionados (
                            {selectedElementIdsToDelete.length})
                          </TrueffortButton>
                        </Box>
                        {getButtonEstimate()}
                      </Grid>
                    </Grid>

                    <Menu
                      id="idElementsFilterDashboards"
                      anchorEl={anchorElemFilter}
                      open={openOptions}
                      onClose={() => setAnchorElemFilter(null)}
                    >
                      {menuNumber == 1 && (
                        <div>
                          <MenuItem
                            id="idStatus_all"
                            key="all"
                            sx={{
                              fontSize: ".8rem!important",
                              color:
                                selectedStatuses.length === 0 ? "#777777" : "",
                            }}
                            onClick={() => handleChangeStatus({ name: "all" })}
                          >
                            {t("Mostrar todos")}
                          </MenuItem>

                          {statusesProject.map((s: any, i: number) => (
                            <MenuItem
                              id={"idStatus_" + (i + 1)}
                              key={s}
                              sx={{
                                fontSize: ".8rem!important",
                                color:
                                  selectedStatuses.findIndex(
                                    (st: any) => st === s,
                                  ) != -1
                                    ? "#777777"
                                    : "",
                              }}
                              onClick={() => handleChangeStatus(s)}
                            >
                              {s.name}
                            </MenuItem>
                          ))}
                        </div>
                      )}
                      {menuNumber === 2 && (
                        <div>
                          <MenuItem
                            id="idSprint_all"
                            key="all"
                            sx={{
                              fontSize: ".8rem!important",
                              color:
                                selectedSprints.length === 0 ? "#777777" : "",
                            }}
                            onClick={() => handleChangeSprint("all")}
                          >
                            {t("Mostrar todos")}
                          </MenuItem>
                          {sprintsFromTasks.map((s: any, i: number) => (
                            <MenuItem
                              id={"idSprint_" + (i + 1)}
                              key={s}
                              sx={{
                                fontSize: ".8rem!important",
                                color:
                                  selectedSprints.findIndex(
                                    (st: any) => st === s,
                                  ) != -1
                                    ? "#777777"
                                    : "",
                              }}
                              onClick={() => handleChangeSprint(s)}
                            >
                              {s}
                            </MenuItem>
                          ))}
                        </div>
                      )}
                    </Menu>
                    <HelperDialog
                      title={t(
                        helperDialogs["estimationInteroperability"][7].title,
                      )}
                      body={t(
                        helperDialogs["estimationInteroperability"][7].body,
                      )}
                      dialogIndex={7}
                      totalDialogs={8}
                      handleNext={handleActiveHelperChange}
                      isOpen={activeHelperDialogIndex === 7}
                      handleClose={handleClose}
                    >
                      <div></div>
                      <TableContainer component={Paper} sx={{ width: "100%" }}>
                        <TableElementsInteroperability
                          elements={filteredElements}
                          elementTypes={elementTypes}
                          t={t}
                          matches={matches}
                          handleElementTypeChange={handleElementTypeChange}
                          handleElementDurationChange={
                            handleElementDurationChange
                          }
                          handleElementEffortChange={handleElementEffortChange}
                          handleElementSizeChange={handleElementSizeChange}
                          handleElementComplexityChange={
                            handleElementComplexityChange
                          }
                          handleDeleteElement={handleDeleteElement}
                          users={users}
                          needEstimated={false}
                          deleteUser={deleteUser}
                          numberOfColumns={numberOfColumns}
                          idEstimationType={idSelectedEstimationType}
                          selectedAPI={selectedAPI}
                          selectedElementIdsToDelete={
                            selectedElementIdsToDelete
                          }
                          handleToggleElementToDelete={
                            handleToggleElementToDelete
                          }
                          isElementIgnored={isElementMappedToTerminada}
                        />
                      </TableContainer>
                    </HelperDialog>
                    {syncedElements.length > 0 && (
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              square
                              sx={{ backgroundColor: "#F5F5F5" }}
                            >
                              <Typography
                                variant="subtitle2"
                                color="#4A4A4A"
                                align="center"
                              >
                                {t("estimation_page.element")}
                              </Typography>
                            </TableCell>

                            <TableCell
                              square
                              sx={{ backgroundColor: "#F5F5F5" }}
                            ></TableCell>

                            <TableCell
                              square
                              sx={{ backgroundColor: "#F5F5F5" }}
                            >
                              <Typography
                                variant="subtitle2"
                                color="#4A4A4A"
                                align="center"
                              >
                                {t("reports_page.general.estatus") +
                                  " (Trueffort)"}
                              </Typography>
                            </TableCell>
                            <TableCell
                              square
                              sx={{ backgroundColor: "#F5F5F5" }}
                            >
                              <Typography
                                variant="subtitle2"
                                color="#4A4A4A"
                                align="center"
                              >
                                {t("reports_page.general.estatus") +
                                  " (" +
                                  selectedAPI.split(" ")[0] +
                                  ")"}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {syncedElements
                            .filter((elem: any) => {
                              const statusMatch =
                                selectedStatuses.length === 0 ||
                                selectedStatuses.includes(elem.status);
                              const sprintMatch =
                                selectedSprints.length === 0 ||
                                selectedSprints.includes(
                                  typeof elem.sprints === "string"
                                    ? elem.sprints
                                    : elem.sprints[0],
                                );
                              return statusMatch && sprintMatch;
                            })
                            .map((elem: any, index: number) => (
                              <>
                                <TableRow style={{ backgroundColor: "white" }}>
                                  <TableCell
                                    style={{
                                      color: /*isDeleted ? '#888' :*/ "#000",
                                    }}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      align="center"
                                    >
                                      {elem.name}
                                    </Typography>
                                  </TableCell>

                                  <TableCell align="center">
                                    <TrueffortChip
                                      color="green"
                                      variant="outlined"
                                      size="small"
                                      label={"EN TRUEFFORT"}
                                    />
                                  </TableCell>

                                  <TableCell>
                                    <Typography
                                      variant="subtitle2"
                                      align="center"
                                    >
                                      {elem.trueffortStatus.name}
                                    </Typography>
                                  </TableCell>

                                  <TableCell>
                                    <Typography
                                      variant="subtitle2"
                                      align="center"
                                    >
                                      {elem.status}
                                    </Typography>
                                  </TableCell>

                                  {false && (
                                    <TableCell>
                                      <Tooltip title="Sincronizar estado">
                                        <IconButton
                                          color="primary"
                                          disabled={isSaving}
                                          onClick={() =>
                                            handleStateUpdate(
                                              elem.apiID,
                                              elem.type,
                                              elem.trueffortStatus,
                                              elem.status,
                                            )
                                          }
                                        >
                                          <CachedIcon />
                                        </IconButton>
                                      </Tooltip>
                                    </TableCell>
                                  )}
                                </TableRow>

                                {index !== syncedElements.length - 1 && ( // Asegura que no agregues la línea después de la última fila
                                  <TableRow>
                                    <TableCell
                                      colSpan={numberOfColumns}
                                      style={{ padding: 0 }}
                                    >
                                      {" "}
                                      {/* Ajusta numberOfColumns con el número de columnas en tu tabla */}
                                      <Box
                                        borderBottom={1}
                                        borderColor="grey.300"
                                      />
                                    </TableCell>
                                  </TableRow>
                                )}
                              </>
                            ))}
                        </TableBody>
                      </Table>
                    )}

                    <Grid
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      {getButtonEstimate()}
                    </Grid>
                  </>
                )
              )}
            </CardContent>
          </Card>
        </Paper>
      </Container>
    </SiteWrapper>
  );
};

export default APIProjectsInfo;
